import { CrudBuilderConfig } from '../../components/crudbuilder/models/crud-builder-config';
import { FieldConfig } from '../../components/crudbuilder/models/field-config';
import { createPerson, Person } from '../../state/people';

export class PeopleCrudBuilderConfigClass extends CrudBuilderConfig {
  singular   = 'Person';
  customTitle = 'Maak Een Nieuwe Persoon Aan';
  plural     = 'Gezin';
  modelAlias = 'person';
  path       = 'people';
  fields     = [
    new FieldConfig('first_name', 'string', 'Voornaam'),
    new FieldConfig('middle_name', 'string', 'Tussenvoegsel'),
    new FieldConfig('last_name', 'string', 'Achternaam'),
    new FieldConfig('email', 'email'),
    new FieldConfig('date_of_birth', 'date', 'Geboortedatum'),
    new FieldConfig('gender', 'gender', 'Geslacht'),
    new FieldConfig('phone_number', 'phone', 'Telefoonnummer'),
    new FieldConfig('mobile_number', 'phone', 'Soort gezinslid'),
    new FieldConfig('marital_status_configuration_id', FieldConfig.TYPE_MARITAL_STATUS_CONFIG, 'Burgerlijke staat', 'marital_status'),
    new FieldConfig('nationality_configuration_id', 'nationality', 'Nationaliteit'),
    new FieldConfig('relation_configuration_id', 'relation', 'Soort gezinslid'),
    new FieldConfig('bsn', FieldConfig.TYPE_NUMBER, 'BSN'),
    new FieldConfig('education_configuration_id', FieldConfig.TYPE_RELATIONCONFIG, 'Opleiding', 'education'),
    new FieldConfig('smokes', FieldConfig.TYPE_BOOLEAN_DATA, 'Rookt u?'),
    new FieldConfig('quit_smoking', FieldConfig.TYPE_BOOLEAN_DATA, 'Indien ja, bent u van plan te stoppen met roken binnen 1 maand?'),
    new FieldConfig('length', FieldConfig.TYPE_NUMBER, 'Lengte'),
    new FieldConfig('weight', FieldConfig.TYPE_NUMBER, 'Gewicht'),
  ];

  readFields = [
    new FieldConfig('name', 'function', 'Naam', {
      from: (model: Person) => {
        if (model.middle_name) {
          return model.first_name + ' ' + model.middle_name + ' ' + model.last_name;
        } else {
          return model.first_name + ' ' + model.last_name;
        }
      }
    }),
    new FieldConfig('gender', 'string', 'Geslacht'),
    new FieldConfig('date_of_birth', 'date', 'Geboortedatum'),
    new FieldConfig('phone_number', 'string', 'Telefoonnummer'),
    new FieldConfig('mobile_number', 'string', 'Mobiel nummer'),
    new FieldConfig('marital_status_configuration_id', 'function', 'Burgerlijke staat', {
      from: (model: Person) => {
        if (model.marital_status) {
            return model.marital_status.name;
        }

        return null;
      }
    }),
    new FieldConfig('nationality_configuration_id', 'nationality', 'Nationaliteit'),
    new FieldConfig('relation_configuration_id', 'relation', 'Soort gezinslid'),
    new FieldConfig('bsn', 'string', 'BSN'),
  ];

  getModel() {
    return createPerson({});
  }

  getReadTitle(model: Person) {
    return model.first_name + ' ' + model.last_name;
  }

  editPreprocess(model: Person) {
    if (!model) {
      return;
    }
    console.log('edit preprocess');
    const newModel                        = {...model};
    newModel.email                        = model.user?.email;
    newModel.nationality_configuration_id = model.nationality.id;
    if(model.relation) {
      newModel.relation_configuration_id    = model.relation.id;
    }
    return newModel;
  }

  runBeforeSavingOnEditView(model: Person) {
    // We need to do this because updating the person does not support updating the user's email.
    // It will error out and say the email is already taken.
    model.email = '';
    return model;
  }
};


export const PeopleCrudBuilderConfig = new PeopleCrudBuilderConfigClass();
